(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('Excel', Excel);

    Excel.$inject = ['fileDownloader'];
    /* @ngInject */
    function Excel(downloader) {
        return {
            downloadExcel: downloadExcel
        }

        function tableToCsv(tableId, html) {
            var $table = html ? $(html) :  $(tableId);
            var $rows = $table.find('tr:has(th), tr:has(td)');

            // Temporary delimiter characters unlikely to be typed by keyboard
            // This is to avoid accidentally splitting the actual contents
            var tmpColDelim = String.fromCharCode(11); // vertical tab character
            var tmpRowDelim = String.fromCharCode(0); // null character

            // actual delimiter characters for CSV format
            var colDelim = '","';
            var rowDelim = '"\r\n"';

            // Grab text from table into CSV formatted string
            var csv = '"' + $rows.map(function (i, row) {
                var $row = $(row),
                $cols = $row.find('th, td');

                return $cols.map(function (j, col) {
                    var $col = $(col);
                    var text = $col.text();
                    if (text) {
                        text = text.trim();
                    }

                    return text.replace(/"/g, '""'); // escape double quotes

                }).get().join(tmpColDelim);

            }).get().join(tmpRowDelim)
                .split(tmpRowDelim).join(rowDelim)
                .split(tmpColDelim).join(colDelim) + '"';

            return csv;
        }

        function downloadExcel(tableId, downloadName, html) {
            var data = tableToCsv(tableId, html);
            downloader.download(data, "data:application/csv", downloadName);
        }
    }
})();
